import React, { useEffect, useState } from 'react';
import { useUiTheme } from 'framework/uiTheme';
import { useDidUpdateEffect } from 'framework/utils';
import Fade from '../../ui/mui-builder/Fade/Fade';
import Loading from '../../ui/mui-builder/Loading/Loading';
import SmallLoader from '../../ui/mui-builder/Loading/SmallLoader';

interface ListLoadingDecoratorProps {
  children: React.ReactNode;
  isSmallLoader?: boolean;
  loading?: boolean;
  items?: any[];
  hasBackground?: boolean;
  hasPositionFixed?: boolean;
  isInitialPosition?: boolean;
}

const ListLoadingDecorator = ({
  children,
  isSmallLoader = false,
  loading = false,
  items = [],
  ...props
}: ListLoadingDecoratorProps) => {
  const [shouldRender, setShouldRender] = useState(true);
  const {
    Loading: ThemedLoading = Loading,
    SmallLoader: ThemedSmallLoader = SmallLoader,
    Fade: ThemedFade = Fade,
  } = useUiTheme();

  useDidUpdateEffect(() => {
    setShouldRender(true);
  }, [items]);

  useEffect(() => {
    if (loading) {
      setShouldRender(false);
    }
  }, [loading]);

  if (loading) {
    return isSmallLoader ? <ThemedSmallLoader /> : <ThemedLoading {...props} />;
  }

  return (
    <ThemedFade in={shouldRender} timeout={0}>
      <div>{children}</div>
    </ThemedFade>
  );
};

export default ListLoadingDecorator;
